module.exports = "/images/gt.svg?819549540261388f00f9d587e9347e90";